import { render } from "./MaintenanceNotice.vue?vue&type=template&id=714c90fe&scoped=true"
import script from "./MaintenanceNotice.vue?vue&type=script&lang=js"
export * from "./MaintenanceNotice.vue?vue&type=script&lang=js"

import "./MaintenanceNotice.vue?vue&type=style&index=0&id=714c90fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714c90fe"]])

export default __exports__